import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const VALUABLES = {
  nickname: 'PRODUCTS.VALUABLES.shortname',
  properties: [
    {
      name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      SUM_INSURED_THOUSANDS_ONLY: true,
      validator: ['', [
        Validators.required,
        Validators.pattern(/^(?:[1-9]\d*)000$/)
      ]]
    },
    { name: 'objectCategory', key: 'OBJECT_CATEGORY', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.VALUABLES_TYPE.PHOTO_TV', value: 'PHOTO_TV', isListEmpty: false },
          { key: 'PROPERTIES_FORM.SELECT_LIST.VALUABLES_TYPE.ELECTRONICS_KOLIBRI', value: 'ELECTRONICS', isListEmpty: false },
          { key: 'PROPERTIES_FORM.SELECT_LIST.VALUABLES_TYPE.JEWLERY', value: 'JEWLERY', isListEmpty: false },
          { key: 'PROPERTIES_FORM.SELECT_LIST.VALUABLES_TYPE.MUSIC', value: 'MUSIC', isListEmpty: false },
          { key: 'PROPERTIES_FORM.SELECT_LIST.VALUABLES_TYPE.HOBBY_EQUIPMENT', value: 'HOBBY_EQUIPMENT', isListEmpty: false },
          { key: 'PROPERTIES_FORM.SELECT_LIST.VALUABLES_TYPE.ART', value: 'ART', isListEmpty: false },
          { key: 'PROPERTIES_FORM.SELECT_LIST.VALUABLES_TYPE.CLOTHES', value: 'CLOTHES', isListEmpty: false },
          { key: 'PROPERTIES_FORM.SELECT_LIST.VALUABLES_TYPE.ANTIQUES_100_YEARS', value: 'ANTIQUES_100_YEARS', isListEmpty: false },
          { key: 'PROPERTIES_FORM.SELECT_LIST.VALUABLES_TYPE.SPORTS_EQUIPMENT', value: 'SPORTS_EQUIPMENT', isListEmpty: false },
          { key: 'PROPERTIES_FORM.SELECT_LIST.VALUABLES_TYPE.SPORT_SPECIAL', value: 'SPORT_SPECIAL', isListEmpty: false },
          { key: 'PROPERTIES_FORM.SELECT_LIST.VALUABLES_TYPE.OTHER', value: 'OTHER', isListEmpty: false }
        ]
      }
    },
    {
      name: 'objectCategoryType', key: 'OBJECT_CATEGORY_TYPE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: []
      },
      customValueConfig: {
        PHOTO_TV: {
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.PHOTO_VIDEOCAMERA', value: 'PHOTO_VIDEOCAMERA' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.TV', value: 'TV' }
            ]
          }
        },
        ELECTRONICS: {
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.PC', value: 'PC' }
            ]
          }
        },
        JEWLERY: {
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.CLOCK', value: 'CLOCK' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.POCKET_WATCH', value: 'POCKET_WATCH' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.SILVER', value: 'SILVER' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.OTHER', value: 'OTHER' },
            ]
          }
        },
        MUSIC: {
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.SPEAKER', value: 'SPEAKER' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.INSTRUMENT', value: 'INSTRUMENT' },
            ]
          }
        },
        HOBBY_EQUIPMENT: {
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.BINOCULARS', value: 'BINOCULARS' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.GLASS_ART', value: 'GLASS_ART' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.SCULPTURE_OF_METAL', value: 'SCULPTURE_OF_METAL' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.SCULPTURE_OF_STONE', value: 'SCULPTURE_OF_STONE' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.TEXTILE_ART', value: 'TEXTILE_ART' }
            ]
          }
        },
        ART: {
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.PICTURE_ART', value: 'PICTURE_ART' }
            ]
          }
        },
        CLOTHES: {
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.BUNAD', value: 'BUNAD' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.BUNAD_WITH_BUNAD_SILVER',
                value: 'BUNAD_WITH_BUNAD_SILVER' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.FUR', value: 'FUR' },
            ]
          }
        },
        SPORTS_EQUIPMENT: {
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.BICYCLE', value: 'BICYCLE' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.GOLF_EQUIPMENT', value: 'GOLF_EQUIPMENT' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.RIDING_SADDLE', value: 'RIDING_SADDLE' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.FISHING_EQUIPMENT', value: 'FISHING_EQUIPMENT' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.ARMS', value: 'ARMS' }
            ]
          }
        },
        SPORT_SPECIAL: {
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.DIVING_EQUIPMENT', value: 'DIVING_EQUIPMENT' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.PARACHUTE', value: 'PARACHUTE' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.HANG_OR_PARAGLIDER', value: 'HANG_OR_PARAGLIDER' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.SKIS_AND_BOOTS_FOR_ALPINE', value: 'SKIS_AND_BOOTS_FOR_ALPINE' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.SKIS_AND_BOOTS_FOR_CROSS_COUNTRY_SKIING', value: 'SKIS_AND_BOOTS_FOR_CROSS_COUNTRY_SKIING' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.SKIS_AND_BOOTS_FOR_TELEMARK', value: 'SKIS_AND_BOOTS_FOR_TELEMARK' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.SNOWBOARD', value: 'SNOWBOARD' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.SKATEBOARD', value: 'SKATEBOARD' }
            ]
          }
        },
        ANTIQUES_100_YEARS: {
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.OTHER', value: 'OTHER' },
            ]
          }
        },
        OTHER: {
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.HEARING_AID', value: 'HEARING_AID' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.GLASSES', value: 'GLASSES' },
            ]
          }
        }
      }
    },
    { name: 'objectDescription', key: 'OBJECT_DESCRIPTION', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: [''],
    },
    { name: 'serialNumber', key: 'SERIAL_NUMBER', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: [''],
    },
  ],
  icon:'valuables'
};
